/** модальное окно для выбора категорий в требуемых случаях */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { onEnter, setOnChange } from "components/special";
import { FloatModal } from "components/special";

const { api } = adminAPI.actions;

const FloatReceiptsServicesModal = (props) => {
  return (
    <FloatModal
      header={<IntlMessages id="Payments.ReceiptsServices" />}
      {...props}
      head={(searchServices, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <IntlMessages id="name" />
            </th>
            <th>
              <IntlMessages id="type" />
            </th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(service, clickHandler) => (
        <>
          <td onClick={clickHandler} className={!service.enabled ? "text-strike" : ""}>
            {service.name}
          </td>
          <td>
            <IntlMessages id={`ReceiptsServicesTypes.${service.type}`} />
          </td>
          <td></td>
        </>
      )}
    />
  );
};

const FloatReceiptsServices = (props) => {
  return <FloatReceiptsServicesModal {...props} />;
};
export default connect(null, {
  getData: api.get("/api/payments/receipts/services"),
})(FloatReceiptsServices);
